import { GetBlacklistResponse } from '../../type'
import BlacklistTable from '../BlacklistTable'

interface BlacklistListingProps {
	data: GetBlacklistResponse['data']
	total: number
	isLoading: boolean
}

export default function BlacklistListing({
	data,
	total,
	isLoading,
}: BlacklistListingProps) {
	return (
		<div className="space-y-4">
			{/* Header */}
			<div className="flex items-center justify-between">
				<h2 className="text-2xl font-semibold">
					จัดการ Blacklist ({total} รายการ)
				</h2>
			</div>

			{/* Table */}
			<BlacklistTable data={data} total={total} isLoading={isLoading} />
		</div>
	)
}
